import hooks from './payment-methods.hooks';
import createSchema from './payment-methods.schema';

export default (app) => {
  const service = app.service('api/payment-methods');
  // TODO: Remove this with feathers-dataloader update
  service.options = {
    id: 'id'
  };
  service.schema = createSchema(app);
  service.hooks(hooks);
};
